type LabelValue = {
  label: string;
  value: string;
};

export function toLabelValue<T>(
  data: T[],
  options: {
    labelKey: keyof T;
    valueKey: keyof T;
  },
): LabelValue[] {
  return data.map((item) => ({
    label: String(item[options.labelKey]),
    value: item[options.valueKey] as string,
  }));
}
